import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  loading: false,
  message: null,
  errors: null,
  homeAlerts: []
};

// A slice

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    loadingUi: (state) => {
      state.loading = true;
    },
    stopLoadingUi: (state) => {
      state.loading = false;
    },
    clearMessage: (state) => {
      state.message = null;
    },
    setMessage: (state, action) => {
      try {
        state.message = {
          error: false,
          message: action?.payload
        };
      } catch (err) {
        state.message = {
          error: true
        };
      }
    },
    setError: (state, action) => {
      try {
        state.message = {
          error: true,
          message: action?.payload[0]
        };
      } catch (err) {
        state.message = {
          error: true
        };
      }
    },
    setHomeAlert: (state, action) => {
      try {
        state.homeAlerts = [...state.homeAlerts, action?.payload];
      } catch (err) {
        console.log(err);
      }
    },
    clearHomeAlert: (state, action) => {
      try {
        const tempHomeAlerts = [...state.homeAlerts];
        const index = tempHomeAlerts.findIndex((alert) => alert.id === action.payload);
        tempHomeAlerts.splice(index, 1);
        state.homeAlerts = [...tempHomeAlerts];
      } catch (err) {
        console.log(err);
      }
    },
    clearAllHomeAlert: (state) => {
      try {
        state.homeAlerts = [];
      } catch (error) {
        console.log(error);
      }
    }
  }
});

const {
  loadingUi,
  stopLoadingUi,
  clearMessage,
  setMessage,
  setError,
  setHomeAlert,
  clearHomeAlert,
  clearAllHomeAlert
} = uiSlice.actions;

export const uiSelector = (state) => state.ui;

const uiReducer = uiSlice.reducer;

export default uiReducer;

// Actions
export const startUiLoading = () => async (dispatch) => {
  dispatch(loadingUi());
};

export const stopUiLoading = () => async (dispatch) => {
  dispatch(stopLoadingUi());
};

export const clearUiMessage = () => async (dispatch) => {
  dispatch(clearMessage());
};

export const setUiError = (errorMessage) => async (dispatch) => {
  dispatch(setError(errorMessage));
};

export const setUiMessage = (message) => async (dispatch) => {
  dispatch(setMessage(message));
};

export const setHomeAlertMessage = (alert) => async (dispatch) => {
  dispatch(setHomeAlert(alert));
};

export const clearHomeAlertMessage = (id) => async (dispatch) => {
  dispatch(clearHomeAlert(id));
};

export const clearAllHomeAlertMessage = () => async (dispatch) => {
  dispatch(clearAllHomeAlert());
};
